import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Avatar } from "@mui/material";
import { selectUser } from "../../../modules/login/selectors";
import { selectAdmin } from "../../../modules/admin/selectors";
import { propsTypes } from "../../constants/field-constants";
import styles from "./UserAvatar.styles";
import type { RootState } from '../../../reducers';

type AvatarProps = {
  src?: string | null;
  alt?: string;
  children?: React.ReactNode;
  sx?: any;
}
interface DashboardProps {
  stylesType: string;
  userData: {
    userAvatar?: string;
    userInitials?: string;
  };
  users: {
    selectedUserAvatar?: string;
    selectedUserInitials?: string;
  };
}
export const SafeAvatar: React.FC<AvatarProps> = ({ src, alt, children, sx }) => {
  const [imageSrc, setImageSrc] = useState<string | undefined>(src ?? undefined);
  useEffect(() => {
    setImageSrc(src ?? undefined);
  }, [src]);
  return (
    <Avatar
      alt={alt}
      src={imageSrc}
      sx={sx}
      onError={() => setImageSrc(undefined)}
    >
      {children}
    </Avatar>
  )
};

const UserAvatar = ({ userData, users, stylesType }: DashboardProps) => {
  const { userAvatar, userInitials } = userData;
  const { selectedUserAvatar, selectedUserInitials } = users;
  return (
    <>
      {stylesType === propsTypes.ADMIN_PANEL ? (
        <SafeAvatar
          alt="User avatar"
          src={selectedUserAvatar}
          sx={styles.avatarAdminPanel}
        >
          {selectedUserInitials}
        </SafeAvatar>
      ) : stylesType === propsTypes.DASHBOARD ? (
        <SafeAvatar alt="User avatar" src={userAvatar} sx={styles.cardAvatar}>
          {userInitials}
        </SafeAvatar>
      ) : stylesType === propsTypes.LEADGEN ? (
        <SafeAvatar alt="User avatar" sx={styles.leadgenEntityRatingAvatar}>
          93.73
        </SafeAvatar>
      ) : (
        <SafeAvatar alt="User avatar" src={userAvatar} sx={styles.defaultAvatar}>
          {userInitials}
        </SafeAvatar>
      )}
    </>
  );
};
function mapStateToProps(state: RootState) {
  const userData = selectUser(state);
  const users = selectAdmin(state);
  return { userData, users };
}

export default connect(mapStateToProps)(UserAvatar);
